import { render, staticRenderFns } from "./InstagramAuthorization.vue?vue&type=template&id=4e562e06&scoped=true"
import script from "./InstagramAuthorization.vue?vue&type=script&lang=js"
export * from "./InstagramAuthorization.vue?vue&type=script&lang=js"
import style0 from "./InstagramAuthorization.vue?vue&type=style&index=0&id=4e562e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e562e06",
  null
  
)

export default component.exports